// @ts-nocheck
import {useNavigation} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import NavbarWithAction from '../../../components/NavbarWithAction';
import {RootStore} from '../../../redux/store';
import {E_NAVIGATION_DESTINATIONS} from '../../../@types';
import Container from '../../../components/Container';
import InviteCodeGenerator from '../../More/components/InviteCodeGenerator';
import {GetDeliveries, setDeliveriesTabSelected} from '../deliveriesReducer';
import {getDeliveryPermissions} from '../permissions';
import DeliveryHeaderTabs from '../components/DeliveryHeaderTabs';
import Deliveries from './Deliveries';
import Packages from './Packages';
import {getUnclaimedPackagesCount} from '../../../utils/packages';

export default function DeliveriesPackages() {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const currentUnitLink = useSelector((state: RootStore) =>
    state.units.unitLinks?.find(link => link.isDefault === true),
  );
  const deliveriesCount = useSelector(
    (state: RootStore) => state.deliveries.deliveries?.length ?? 0,
  );
  const deliveriesTabShown = useSelector(
    (state: RootStore) => state.deliveries.deliveriesTabShown,
  );
  const packages = useSelector(
    (state: RootStore) => state.packages.packages ?? [],
  );
  const unclaimedPackagesCount = getUnclaimedPackagesCount(packages);
  const deliveryPermissions = getDeliveryPermissions(
    currentUnitLink?.deliveryPermission,
  );
  const [showInviteCodeModal, setShowInviteCodeModal] = useState(false);
  const [activeTab, setActiveTab] = useState(
    deliveryPermissions.canView ? 'Deliveries' : 'Packages',
  );

  const onClickGenerateInviteCode = () => {
    setShowInviteCodeModal(true);
  };

  useEffect(() => {
    dispatch(GetDeliveries());
  }, [dispatch]);

  useEffect(() => {
    dispatch(setDeliveriesTabSelected(activeTab === 'Deliveries'));
  }, [activeTab, dispatch]);

  return (
    <Container>
      <NavbarWithAction
        hasSignOut={false}
        navigation={navigation}
        hasBackArrow={false}
        title="deliveries"
        showCurrentUnit
        hasAdd={deliveriesTabShown && deliveryPermissions.canAdd}
        onClickAdd={() => navigation.navigate('Add delivery', { delivery: null })}
        showUnitPicture={false}
        onClickFilter={() => null}
        hasFilter={false}
        hasAccessCard
        onClickAccessCard={() =>
          navigation.navigate(E_NAVIGATION_DESTINATIONS.ID_CARD)
        }
        fullScreen
        hasMoreMenu
        hasProfile
        hasOthers
        hasGenerateInviteCode
        hasSwitchUnit
        switchUnit={() => {
          navigation.navigate('Units');
        }}
        openProfile={() => navigation.navigate('Edit Profile')}
        onClickGenerateInviteCode={onClickGenerateInviteCode}
        openOthers={() => navigation.navigate('Others')}
      />
      <DeliveryHeaderTabs
        activeTab={activeTab}
        deliveriesCount={deliveriesCount}
        setActiveTab={setActiveTab}
        showDeliveries={deliveryPermissions.canView}
        unclaimedPackagesCount={unclaimedPackagesCount}
      />
      {activeTab === 'Packages' || !deliveryPermissions.canView ? (
        <Packages />
      ) : (
        <Deliveries embedded fetchOnMount={false} />
      )}
      <InviteCodeGenerator
        modalVisible={showInviteCodeModal}
        closeModal={() => setShowInviteCodeModal(false)}
      />
    </Container>
  );
}
